import { api } from '@/lib/api'

export type ExpenseCategory = {
  id: number
  agenda_id: string
  name: string
  is_active: boolean
  created_at: string
}

export type CreateExpenseCategoryPayload = {
  name: string
}

export type UpdateExpenseCategoryPayload = {
  name: string
}

export const getExpenseCategoriesService = (agendaId: string): Promise<ExpenseCategory[]> =>
  api.get<ExpenseCategory[]>(`/agendas/${agendaId}/expense-categories`).then((res) => res.data)

export const createExpenseCategoryService = (
  agendaId: string,
  payload: CreateExpenseCategoryPayload,
): Promise<ExpenseCategory> =>
  api.post<ExpenseCategory>(`/agendas/${agendaId}/expense-categories`, payload).then((res) => res.data)

export const updateExpenseCategoryService = (
  agendaId: string,
  categoryId: number,
  payload: UpdateExpenseCategoryPayload,
): Promise<ExpenseCategory> =>
  api
    .put<ExpenseCategory>(`/agendas/${agendaId}/expense-categories/${categoryId}`, payload)
    .then((res) => res.data)

export const deleteExpenseCategoryService = (agendaId: string, categoryId: number): Promise<void> =>
  api.delete(`/agendas/${agendaId}/expense-categories/${categoryId}`).then((res) => res.data)
